<template>
  <div class="flex flex-column gap-[16px] px-[24px] mt-[16px]">
    <b-col
      md="8"
      class="p-0 flex items-center"
    >
      <b-col
        md="4"
        class="p-0"
      >
        Nama Bank
      </b-col>
      <b-col
        md="7"
        class="border rounded-[8px] p-[7px]"
      >
        {{ dataDetail.bank_name.new }}
      </b-col>
      <b-col
        v-if="isNewData(dataDetail.bank_name.new, dataDetail.bank_name.old)"
        cols="1"
        class="p-0 flex"
      >
        <div class="ml-auto rounded-full h-[22px] w-[22px] flex items-center justify-center bg-[#FBA63C]">
          <span
            id="bank-name-old"
            class=" k-info-circle h-fit rounded-full text-white text-2xl"
          />
          <BPopover
            target="bank-name-old"
            triggers="hover"
            placement="top"
          ><span class="text-muted">Detail Existing:</span> <br> <span class="font-semibold">{{ dataDetail.bank_name.old || 'Tidak ada data sebelumnya' }}</span></BPopover>
        </div>
      </b-col>
    </b-col>

    <b-col
      md="8"
      class="p-0 flex items-center"
    >
      <b-col
        md="4"
        class="p-0"
      >
        No Rekening
      </b-col>
      <b-col
        md="7"
        class="border rounded-[8px] p-[7px]"
      >
        {{ dataDetail.account_number.new }}
      </b-col>
      <b-col
        v-if="isNewData(dataDetail.account_number.new, dataDetail.account_number.old)"
        cols="1"
        class="p-0 flex"
      >
        <div class="ml-auto rounded-full h-[22px] w-[22px] flex items-center justify-center bg-[#FBA63C]">
          <span
            id="rek-num-old"
            class=" k-info-circle h-fit rounded-full text-white text-2xl"
          />
          <BPopover
            target="rek-num-old"
            triggers="hover"
            placement="top"
          ><span class="text-muted">Detail Existing:</span> <br> <span class="font-semibold">{{ dataDetail.account_number.old || 'Tidak ada data sebelumnya' }}</span></BPopover>
        </div>
      </b-col>
    </b-col>

    <b-col
      md="8"
      class="p-0 flex items-center"
    >
      <b-col
        md="4"
        class="p-0"
      >
        Nama Pemilik Bank
      </b-col>
      <b-col
        md="7"
        class="border rounded-[8px] p-[7px]"
      >
        {{ dataDetail.account_holder_name.new }}
      </b-col>
      <b-col
        v-if="isNewData(dataDetail.account_holder_name.new, dataDetail.account_holder_name.old)"
        cols="1"
        class="p-0 flex"
      >
        <div class="ml-auto rounded-full h-[22px] w-[22px] flex items-center justify-center bg-[#FBA63C]">
          <span
            id="holder-name-old"
            class=" k-info-circle h-fit rounded-full text-white text-2xl"
          />
          <BPopover
            target="holder-name-old"
            triggers="hover"
            placement="top"
          ><span class="text-muted">Detail Existing:</span> <br> <span class="font-semibold">{{ dataDetail.account_holder_name.old || 'Tidak ada data sebelumnya' }}</span></BPopover>
        </div>
      </b-col>
    </b-col>
  </div>
</template>

<script>
export default {
  props: {
    dataDetail: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    isNewData(newData, oldData) {
      if (newData && oldData) {
        if (newData === oldData) {
          return false
        }
        return true
      }
      if (newData && oldData === '') {
        return true
      }

      return false
    },
  },
}
</script>
